import React from 'react';
import { ForeCastType } from 'shared/interface/enums';

interface IProps {
	data: any;
	content: any;
}

const HoverTooltipSVG: React.FC<IProps> = (props) => {
	const { content, data } = props;
	const { fontSize, fontFamily, fontFill } = data;
	const X = 10;
	const startY = 20;
	const tspans = [];
	const squareSize = 9; // Size of the square box
	let position = 0;

	// Function to clean the value
	const replaceValue = (value: string) => {
		if (!value) return '';

		// Only process if the value contains NaN
		if (typeof value === 'number') {
			return value;
		} else {
			if (value.includes('NaN')) {
				// Extract year using regex
				const yearMatch = value.match(/\d{4}/);
				if (yearMatch) {
					return `NaN - ${yearMatch[0]}`;
				}
				// If no year found, just return NaN
				return 'NaN';
			}
			// Return original value if it doesn't contain NaN
			return value;
		}
	};

	for (let i = 0; i < content.y.length; i++) {
		const y = content.y[i];
		const labelPositionY = startY + fontSize + position - (i !== 0 ? 10 : 0) + (i !== 0 && content.y[i - 1].indicator.length > 0 ? fontSize : 0);
		const boxPositionY = labelPositionY - squareSize;
		position = labelPositionY;
		let positionX = 0;

		if (y.isShowLabel) {
			tspans.push(
				<g key={`Group-${i}`} x={X} y={startY}>
					<defs>
						<filter id='blurEffect'>
							<feGaussianBlur stdDeviation='2' />
						</filter>
						<filter id='shadowFilter' x='-50%' y='-50%' width='200%' height='200%'>
							<feDropShadow dx='0' dy='4' stdDeviation='2' floodColor='rgba(0, 0, 0, 0.25)' />
						</filter>
					</defs>
					<g y={startY}>
						{/* color box */}
						{y.isMultiTooltip &&
							y.stroke.map((item: any, index: number) => (
								<rect
									x={X} // Adjust the x position of the box
									y={`${(index + 1.5) * 16}px`}
									width={squareSize}
									height={squareSize}
									rx={1}
									ry={1}
									fill={item}
									filter='url(#shadowFilter)'
									style={{ stroke: 'none' }}
								/>
							))}
						{!y.isMultiTooltip && (
							<rect
								x={X} // Adjust the x position of the box
								y={boxPositionY}
								width={squareSize}
								height={squareSize}
								rx={1}
								ry={1}
								fill={y.stroke}
								style={{ stroke: 'none' }}
							/>
						)}

						<svg>
							<defs>
								<linearGradient
									id='gradient#FF9100'
									x1={`${y?.forecastKeyLabel?.length === 1 ? '90%' : '100%'} `}
									y1={`${y?.forecastKeyLabel?.length === 1 ? '100%' : '40%'} `}
									x2={`${y?.forecastKeyLabel?.length === 1 ? '40%' : '80%'} `}
									y2={`${y?.forecastKeyLabel?.length === 1 ? '40%' : '40%'} `}
								>
									<stop offset='0%' stopColor='#081D34' />
									<stop offset='100%' stopColor='#FF9100' />
								</linearGradient>
								<linearGradient
									id='gradient#8CEA80'
									x1={`${y?.forecastKeyLabel?.length === 2 ? '90%' : y?.forecastKeyLabel?.length === 1 ? '90%' : '80%'} `}
									y1={`${y?.forecastKeyLabel?.length === 2 ? '100%' : y?.forecastKeyLabel?.length === 1 ? '100%' : '70%'} `}
									x2={`${y?.forecastKeyLabel?.length === 2 ? '40%' : y?.forecastKeyLabel?.length === 1 ? '40%' : '50%'} `}
									y2={`${y?.forecastKeyLabel?.length === 2 ? '70%' : y?.forecastKeyLabel?.length === 1 ? '70%' : '10%'} `}
								>
									<stop offset='0%' stopColor='#081D34' />
									<stop offset='100%' stopColor='#8CEA80' />
								</linearGradient>
								<linearGradient id='gradient#A81FF8' x1='72.05%' y1='99%' x2='99.98%' y2='100%'>
									<stop offset='0%' stopColor='#A81FF8' />
									<stop offset='100%' stopColor='#081D34' />
								</linearGradient>
								<linearGradient id='gradientDate' x1='100%' y1='0%' x2='0%' y2='20%'>
									<stop offset='0%' stopColor='#081D34' />
									<stop offset='100%' stopColor='#FF9100' />
								</linearGradient>
							</defs>
							<text
								key={`L-${i}`}
								x={X + squareSize + 10} // Adjust the x position of the text
								y={labelPositionY}
								fontFamily={'Outfit'}
								fontSize={fontSize}
								fill={fontFill}
								fontWeight={400}
							>
								{y.isMultiTooltip &&
									y.forecastKeyLabel.map((label: any, index: number) => {
										// Get the value from the array at the correct index
										const value = Array.isArray(y.value) ? y.value[index] : y.value;
										return (
											<>
												<tspan
													x={'22px'}
													key={`label-${label + index}-${index}`}
													y={`${y.label.length > 0 ? (index + 2) * 16 : 10}px`}
												>
													{y.label}
												</tspan>
												<tspan
													x={X + y.label + 10} // Align labels correctly
													key={`label-${label + index + 5}-${index}`}
													y={labelPositionY + index * 16}
													style={{ fontWeight: 700, textTransform: 'capitalize' }}
												>
													{label}:{' '}
												</tspan>

												<tspan
													key={`value-${index}`}
													fontWeight={700}
													filter={y.isValueBlur ? 'url(#blurEffect)' : ''}
													fill={`url(#gradient${y.stroke[index]})`}
												>
													{value}
												</tspan>
											</>
										);
									})}
								{!y.isMultiTooltip && <tspan>{`${y.label.split('$')[0]}: `}</tspan>}
								{!y.isMultiTooltip && (
									<tspan fontWeight={700} filter={`${y.isValueBlur ? 'url(#blurEffect)' : ''} `}>
										{replaceValue(y.value)}
									</tspan>
								)}
							</text>
						</svg>
						{y.indicator.map((indi: any, index: number) => {
							const indicatorBoxPostionX =
								X +
								squareSize +
								(index === 0
									? 0
									: y.indicator[index - 1].label.includes('BB')
									? `${y.indicator[index - 1].label} ${y.indicator[index - 1].value}`.length > 39
										? 280
										: 210
									: 110) +
								positionX;
							positionX = indicatorBoxPostionX;
							const indicatorTextPositionX = indicatorBoxPostionX + squareSize + 10;

							return (
								<g key={`indicator-${i}`}>
									<rect
										x={indicatorBoxPostionX} // Adjust the x position of the box
										y={y.isMultiTooltip ? y.forecastKeyLabel.length * 12 + boxPositionY + fontSize : boxPositionY + fontSize}
										width={squareSize}
										height={squareSize}
										rx={1}
										ry={1}
										fill={indi.stroke}
										style={{ stroke: 'none' }}
									/>
									<text
										key={`L-${i}`}
										x={indicatorTextPositionX} // Adjust the x position of the text
										y={y.isMultiTooltip ? y.forecastKeyLabel.length * 12 + labelPositionY + fontSize : labelPositionY + fontSize}
										fontFamily={'Outfit'}
										fontSize={fontSize}
										fill={fontFill}
										fontWeight={400}
									>
										<tspan>{`${indi.label}: `}</tspan>
										<tspan fontWeight={700}>{indi.value}</tspan>{' '}
									</text>
								</g>
							);
						})}
					</g>
				</g>
			);
		}
	}

	return (
		<g x={X} y={startY}>
			<text
				x={X}
				y={startY}
				fontFamily={fontFamily}
				fontSize={fontSize}
				fill={`${content.y.map((type: any) => type.forecastType === ForeCastType.FORECASTED_PRICE && 'url(#gradientDate)')}`}
				fontWeight={700}
			>
				{content.x}
			</text>
			{tspans}
		</g>
	);
};

export default HoverTooltipSVG;
